import strings from 'lang/lang';
import { ReactComponent as ArrowRight } from 'styles/icon/arrowRight.svg';

function UseCasesLinks() {
  return (
    <ul>
      <li>
        <a href="https://staq.io/use-cases/insurance" target="_blank"><span>{strings.footerList.text.insuranse}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/marketplace" target="_blank"><span>{strings.footerList.text.marketplace}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/gig-economy" target="_blank"><span>{strings.footerList.text.gigEconomy}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/banking" target="_blank"><span>{strings.footerList.text.banking}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/travel" target="_blank"><span>{strings.footerList.text.travel}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/telecommunications" target="_blank"><span>{strings.footerList.text.telecommunications}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/healthcare" target="_blank"><span>{strings.footerList.text.healthcare}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/gaming" target="_blank"><span>{strings.footerList.text.gaming}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/neobanks" target="_blank"><span>{strings.footerList.text.neobanks}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/use-cases/e-commerce" target="_blank"><span>{strings.footerList.text.eCommerce}</span><ArrowRight /></a>
      </li>
    </ul>
  );
}

export default UseCasesLinks;